import { ReactNode, useMemo } from 'react';
import { useListContext } from 'framework/list';
import { PositionSlotListItem } from './types';
import { PositionSlotValidationContext, useComputePositionSlotValidationErrors } from './positionSlotValidationErrors';

export { usePositionSlotValidationErrors } from './positionSlotValidationErrors';

export const PositionSlotValidationProvider = ({ children }: { children: ReactNode }) => {
  const { data, loading } = useListContext();
  const positionSlots = useMemo(() => (data?.items ?? []) as PositionSlotListItem[], [data?.items]);
  const errorsByEmployeeAlias = useComputePositionSlotValidationErrors(
    positionSlots,
    Boolean(loading),
    data?.lastUpdate ?? undefined,
  );
  const contextValue = useMemo(() => ({ errorsByEmployeeAlias }), [errorsByEmployeeAlias]);

  return (
    <PositionSlotValidationContext.Provider value={contextValue}>{children}</PositionSlotValidationContext.Provider>
  );
};
